import axios from "axios";

export default {
    get(params) {
        return axios.get("videos", {
            params: params
        });
    },
    update(id, body) {
        return axios.put(`videos/${id}`, body);
    }
};
